let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fYi1a")).then(() => parcelRequire('lkBga'));